module.exports = __webpack_public_path__ + "fonts/gt-america-standard-bold.0c7c3b3.ttf";